/*
 * BND-102 - Richiesta fattura nel carrello.
 * Sostituisce la vecchia implementazione jQuery del tema FCDB 2.0.
 * Salva i dati come cart attributes via /cart/update.js, come <cart-note> in cart.js.
 */
class InvoiceRequest extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('#fattura');
    this.type = this.querySelector('#societa');
    this.groups = {
      societa: this.querySelector('#societaDiv'),
      codicefiscale: this.querySelector('#codicefiscaleDiv'),
      partitaIVA: this.querySelector('#partitaIVADiv'),
      pecSdi: this.querySelector('#pecSdiDiv'),
      vat: this.querySelector('#vatDiv'),
    };

    if (!this.checkbox || !this.type) return;

    this.save = this.debounce(this.save.bind(this), 400);

    this.checkbox.addEventListener('change', () => {
      this.render();
      this.save();
    });
    this.type.addEventListener('change', () => {
      this.render();
      this.save();
    });
    this.querySelectorAll('input[type="text"]').forEach((input) => {
      input.addEventListener('input', this.save);
      input.addEventListener('change', this.save);
    });

    this.render();
  }

  debounce(fn, wait) {
    if (window.FoxTheme && FoxTheme.utils && FoxTheme.utils.debounce) {
      return FoxTheme.utils.debounce(fn, wait);
    }
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  /* Mostra solo i campi pertinenti al tipo di soggetto selezionato. */
  render() {
    const on = this.checkbox.checked;
    const type = this.type.value;

    this.toggle(this.groups.societa, on);
    this.toggle(this.groups.codicefiscale, on && type !== 'società estera');
    this.toggle(this.groups.partitaIVA, on && type === 'società italiana');
    this.toggle(this.groups.pecSdi, on && type === 'società italiana');
    this.toggle(this.groups.vat, on && type === 'società estera');
  }

  toggle(group, visible) {
    if (!group) return;
    group.hidden = !visible;
    const field = group.querySelector('input, select');
    if (!field) return;
    if (visible) {
      field.setAttribute('required', '');
    } else {
      field.removeAttribute('required');
    }
  }

  value(selector) {
    const el = this.querySelector(selector);
    return el ? el.value.trim() : '';
  }

  /*
   * Quando la fattura non e' richiesta gli altri attributi vengono azzerati,
   * per non lasciare dati fiscali orfani sull'ordine.
   */
  save() {
    const on = this.checkbox.checked;
    const type = this.type.value;
    const italiana = on && type === 'società italiana';
    const estera = on && type === 'società estera';

    const attributes = {
      'Richiedi fattura': on ? 'Yes' : 'No',
      'tipo di società': on ? type : '',
      'codice fiscale': on && !estera ? this.value('#codicefiscale') : '',
      'partita iva': italiana ? this.value('#partitaIVA') : '',
      'PEC SDI': italiana ? this.value('#pecSdi') : '',
      VAT: estera ? this.value('#vat') : '',
    };

    const url =
      window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_update_url
        ? FoxTheme.routes.cart_update_url
        : '/cart/update.js';

    const config =
      window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig
        ? FoxTheme.utils.fetchConfig()
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

    fetch(url, { ...config, body: JSON.stringify({ attributes }) }).catch((error) => {
      console.error('[BND-102] salvataggio dati fattura non riuscito', error);
    });
  }
}

customElements.define('invoice-request', InvoiceRequest);
